import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PatientPortal from './pages/patient-portal';
import TreatmentDocumentation from './pages/clinical-documentation';
import PatientDashboard from './pages/patient-dashboard';
import PatientRecords from './pages/patient-records';
import Login from './pages/login';
import PrescriptionManagement from './pages/medication-management';
import AppointmentScheduling from './pages/appointment-scheduling';
import DiagnosticResults from './pages/lab-results';
import BillingManagement from './pages/billing-management';
import TeamCollaboration from './pages/team-collaboration';
import DentalImagingManagement from './pages/dental-imaging-management';
import PracticeAnalyticsDashboard from './pages/practice-analytics-dashboard';
import TreatmentPlanning from './pages/treatment-planning';
import TreatmentPlanReview from './pages/treatment-plan-review';
import TreatmentOutcomeSurvey from './pages/treatment-outcome-survey';
import QualityMetricsDashboard from './pages/quality-metrics-dashboard';
import DentalPatientIntake from './pages/dental-patient-intake';
import DentalChartingClinicalWorkflow from './pages/dental-charting-clinical-workflow';
import DentalPracticeMarketingHub from './pages/dental-practice-marketing-hub';
import ProviderCredentialingManagement from './pages/provider-credentialing-management';
import PatientCommunicationHub from './pages/patient-communication-hub';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<PatientDashboard />} />
        <Route path="/patient-portal" element={<PatientPortal />} />
        <Route path="/clinical-documentation" element={<TreatmentDocumentation />} />
        <Route path="/patient-dashboard" element={<PatientDashboard />} />
        <Route path="/patient-records" element={<PatientRecords />} />
        <Route path="/login" element={<Login />} />
        <Route path="/medication-management" element={<PrescriptionManagement />} />
        <Route path="/appointment-scheduling" element={<AppointmentScheduling />} />
        <Route path="/lab-results" element={<DiagnosticResults />} />
        <Route path="/billing-management" element={<BillingManagement />} />
        <Route path="/team-collaboration" element={<TeamCollaboration />} />
        <Route path="/dental-imaging-management" element={<DentalImagingManagement />} />
        <Route path="/practice-analytics-dashboard" element={<PracticeAnalyticsDashboard />} />
        <Route path="/quality-metrics-dashboard" element={<QualityMetricsDashboard />} />
        <Route path="/treatment-planning" element={<TreatmentPlanning />} />
        <Route path="/treatment-plan-review" element={<TreatmentPlanReview />} />
        <Route path="/treatment-outcome-survey" element={<TreatmentOutcomeSurvey />} />
        <Route path="/dental-patient-intake" element={<DentalPatientIntake />} />
        <Route path="/dental-charting-clinical-workflow" element={<DentalChartingClinicalWorkflow />} />
        <Route path="/dental-practice-marketing-hub" element={<DentalPracticeMarketingHub />} />
        <Route path="/provider-credentialing-management" element={<ProviderCredentialingManagement />} />
        <Route path="/patient-communication-hub" element={<PatientCommunicationHub />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
